export var ContextGLProfile;
(function (ContextGLProfile) {
    ContextGLProfile[ContextGLProfile["BASELINE"] = 0] = "BASELINE";
    ContextGLProfile[ContextGLProfile["BASELINE_CONSTRAINED"] = 1] = "BASELINE_CONSTRAINED";
    ContextGLProfile[ContextGLProfile["BASELINE_EXTENDED"] = 2] = "BASELINE_EXTENDED";
})(ContextGLProfile || (ContextGLProfile = {}));
